export const domainErrorStatuses = {
  VALIDATION_ERROR: 400,
  PackagingCorrectionUnsupported: 400,
  PackagingCorrectionPriceBasis: 400,
  PackagingNotSupported: 400,
  PackagingContentLocked: 409,
  PackagingCorrectionStale: 409,
  PackagingCorrectionGroupConflict: 409,
  PackagingCorrectionTrackingConflict: 409,
  PackagingCorrectionAmbiguous: 409,
  PackagingCorrectionAccessDenied: 403,
  AccessDenied: 403,
  EmailConfirmationRequired: 403,
  InactiveUser: 403,
  UserEmailAlreadyExists: 409,
  UserEmailAlreadyExistsInactive: 409,
  UsernameAlreadyExists: 409,
  ExternalIdentityConflict: 409,
  AiCreditsRequired: 402,
  AiProviderNotConnected: 409,
  BadRequest: 400,
  CanNotDeleteItemContainerWithChildren: 409,
  CanNotDeleteItemContainerWithItems: 409,
  CanNotDeleteItemContainerWithShares: 409,
  ConcurrentModification: 409,
  Conflict: 409,
  ShopNameConflict: 409,
  FeatureUnavailable: 403,
  ParentNotFound: 404,
  QrCodeAlreadyAssigned: 409,
  QrCodeOwnedByAnotherUser: 404,
  RecordNotFound: 404,
} as const;
